import React, { useState } from "react";
import {
  List,
  ListItemText,
  ListItem,
  Collapse,
  ListItemIcon,
} from "@material-ui/core";
import { ArrowDropDown, ArrowRight } from "@material-ui/icons";

const CollapseComponent = ({ children, groupTitle = "" }) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(!open);
  return (
    <List
      sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItem button onClick={handleClick}>
        <ListItemIcon>{open ? <ArrowDropDown /> : <ArrowRight />}</ListItemIcon>
        <ListItemText primary={groupTitle} />
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </List>
  );
};

export default CollapseComponent;
